module.exports = __webpack_public_path__ + "img/logo.2799cf25.svg";